import React from 'react';

const Background = () => {
  return (
    <div className="bg-shapes">
      <svg
        width="3055"
        height="2970"
        id="screenshot-0d20ed6f-64c8-801b-8007-1fb1fa0c0b2f"
        viewBox="-33 -374425 3055 2970"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        fill="none"
        version="1.1"
      >
        <g id="shape-0d20ed6f-64c8-801b-8007-1fb1fa0c0b2f">
          <g className="fills" id="fills-0d20ed6f-64c8-801b-8007-1fb1fa0c0b2f">
            <path
              d="M-33,-372438.4375L2931.49951171875,-374425L3022,-371455L-33,-372438.4375"
              style={{ fill: 'rgb(170, 0, 30)', fillOpacity: 0.05 }}
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Background;
